var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgRefreshDisabled = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.129 14.773c-1.018 3.194-3.934 5.5-7.371 5.5-4.285 0-7.758-3.581-7.758-8 0-4.418 3.473-8 7.758-8 2.871 0 5.378 1.61 6.72 4m-2.357 1H20v-4",
    stroke: "#10121C",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRefreshDisabled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/RefreshDisabled.2f2b3826.svg";
export { ForwardRef as ReactComponent };